import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import type { BaseButtonStyle } from "components/designV2/buttons/baseButton";
import { Footer } from "./timeReportDetailsPanel.styled";

export type ActionItem =
  | {
      kind: "approve";
      label: string;
      onClick: () => void;
      disabled: boolean;
      isLoading: boolean;
    }
  | {
      kind: "reject";
      label: string;
      onClick: () => void;
      disabled: boolean;
      isLoading: boolean;
    }
  | {
      kind: "retract";
      label: string;
      onClick: () => void;
      disabled: boolean;
      isLoading: boolean;
    }
  | {
      kind: "reset";
      label: string;
      onClick: () => void;
      disabled: boolean;
      isLoading: boolean;
    }
  | {
      kind: "absence";
      label: string;
      onClick: () => void;
      disabled: boolean;
    };

interface ActionFooterProps {
  groupAriaLabel: string;
  actions: ActionItem[];
  denyButtonStyles: Partial<BaseButtonStyle>;
  approveButtonStyles: Partial<BaseButtonStyle>;
}

export const ActionFooter = (props: ActionFooterProps): JSX.Element => {
  const renderAction = (action: ActionItem): JSX.Element => {
    switch (action.kind) {
      case "retract":
        return (
          <SecondaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            disabled={action.disabled}
            isLoading={action.isLoading}
            onClick={action.onClick}
          />
        );
      case "absence":
        return (
          <SecondaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            disabled={action.disabled}
            onClick={action.onClick}
          />
        );
      case "reset":
        return (
          <SecondaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            disabled={action.disabled}
            isLoading={action.isLoading}
            onClick={action.onClick}
          />
        );
      case "reject":
        return (
          <SecondaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            iconName="v2/cross"
            styleOverrides={props.denyButtonStyles}
            disabled={action.disabled}
            isLoading={action.isLoading}
            onClick={action.onClick}
          />
        );
      case "approve":
        return (
          <PrimaryButton
            key={action.kind}
            type="button"
            size="small"
            label={action.label}
            styleOverrides={props.approveButtonStyles}
            disabled={action.disabled}
            isLoading={action.isLoading}
            onClick={action.onClick}
          />
        );
      default: {
        const _exhaustive: never = action;
        return _exhaustive;
      }
    }
  };

  return (
    <Footer role="group" aria-label={props.groupAriaLabel}>
      {props.actions.map((action) => renderAction(action))}
    </Footer>
  );
};
